<template>
  <main class="help">
    <p>{{ msg }}</p>
  </main>
</template>

<script>
  export default {
    name: 'help',
    data () {
      return {
        msg: 'Help'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/pages/Help.vue